import {AttrsSchema, Component} from 'panel';

import {defineAndMakeJsxFactory} from 'common/util/jsx';
import {panel2react} from 'common/util/react';

import {SVG_ICON_NAMES} from '../svg-icon';
import {template} from './template';
import css from './index.inline.styl';

export enum TEXT_HIGHLIGHT_THEME {
  GENERIC = `generic`,
  LIGHT = `light`,
  INFORMATION = `information`,
  SUCCESS = `success`,
  DELETED = `deleted`,
  FAILED = `failed`,
  POSITIVE = `positive`,
  NEGATIVE = `negative`,
  NEUTRAL = `neutral`,
}

export const LENGTH = {
  THIN: `thin`,
  WIDE: `wide`,
};

export const SIZE = {
  SMALL: `small`,
  MEDIUM: `medium`,
  LARGE: `large`,
};

type TextHighlightAttrs = {
  icon?: string;
  length?: string;
  markdown?: string;
  size?: string;
  text?: string;
  theme?: TEXT_HIGHLIGHT_THEME;
  'text-before-icon'?: boolean;
};

interface TextHighlightJsxProps {
  attrs?: TextHighlightAttrs;
}

export class TextHighlight extends Component<EmptyObj, TextHighlightAttrs> {
  static get attrsSchema(): AttrsSchema<TextHighlightAttrs> {
    return {
      ...super.attrsSchema,
      length: {type: `string`, default: LENGTH.THIN, enum: Object.values(LENGTH)},
      size: {type: `string`, default: SIZE.MEDIUM, enum: Object.values(SIZE)},
      theme: {type: `string`, default: TEXT_HIGHLIGHT_THEME.NEUTRAL, enum: Object.values(TEXT_HIGHLIGHT_THEME)},
      icon: {type: `string`, enum: SVG_ICON_NAMES},
      markdown: {type: `string`, description: `Markdown string to be rendered`},
      text: `string`,
      'text-before-icon': {type: `boolean`, description: `Render text to the left of icon`},
    };
  }

  get config() {
    return {
      useShadowDom: true,
      template,
      css,
      helpers: {
        THEME: TEXT_HIGHLIGHT_THEME,
        SIZE,
      },
    };
  }
}

export const TextHighlightEl = defineAndMakeJsxFactory<TextHighlightJsxProps>(`mp-text-highlight`, TextHighlight);
export const TextHighlightReact = panel2react<TextHighlightJsxProps>(`mp-text-highlight`, TextHighlight);
